if (!customElements.get('slide-show-v2')) {
    class SlideShowV2 extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const slideshow = this;
            let prev_buttons = slideshow.querySelectorAll('.flickity-prev');
            let next_buttons = slideshow.querySelectorAll('.flickity-next');
            let align = slideshow.dataset.align == 'center' ? 'center' : 'left';

            let args = {
                wrapAround: true,
                cellAlign: align,
                pageDots: false,
                contain: true,
                fade: true,
                autoPlay: slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
                rightToLeft: false,
                prevNextButtons: true, 
                cellSelector: '.carousel__slide',
                on: {}
            };

            // Initialize Flickity
            const flkty = new Flickity(slideshow, args);
            this.flickityInstance = flkty;

            // Attach button event listeners
            prev_buttons.forEach(button => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    flkty.previous();
                    setTimeout(() => {
                        restartVideosOnSlide(flkty.selectedIndex, flkty);
                    }, 300); // Small delay to allow Flickity transition
                });
            });

            next_buttons.forEach(button => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    flkty.next();
                    setTimeout(() => {
                        restartVideosOnSlide(flkty.selectedIndex, flkty);
                    }, 300); // Small delay to allow Flickity transition
                });
            });

            // Start autoplay only after Flickity is fully initialized
            flkty.on('ready', function () {
                startCustomAutoplay(slideshow);
            });

            // Restart videos when slide changes automatically
            flkty.on('change', function () {
                setTimeout(() => {
                    restartVideosOnSlide(flkty.selectedIndex, flkty);
                }, 300);
            });
        }
    }

    customElements.define('slide-show-v2', SlideShowV2);
}

// Function to restart videos when slide changes
function restartVideosOnSlide(index, flkty) {
    let previousIndex = fizzyUIUtils.modulo(index - 1, flkty.slides.length);
    let prevSlide = flkty.cells[previousIndex]?.element;
    let currentSlide = flkty.cells[index]?.element;

    if (prevSlide) {
        prevSlide.querySelectorAll('video, iframe').forEach(video => {
            if (video.tagName === 'VIDEO') {
                video.pause();
                video.currentTime = 0;
            } else if (video.tagName === 'IFRAME') {
                let src = video.src;
                video.src = '';
                setTimeout(() => {
                    video.src = src;
                }, 100);
            }
        });
    }

    if (currentSlide) {
        currentSlide.querySelectorAll('video, iframe').forEach(video => {
            if (video.tagName === 'VIDEO') {
                video.currentTime = 0;
                video.play();
            } else if (video.tagName === 'IFRAME') {
                let src = video.src;
                video.src = '';
                setTimeout(() => {
                    video.src = src;
                }, 100);
            }
        });
    }
}

// Function to handle autoplay timing
function startCustomAutoplay(slideshow) {
    const flkty = Flickity.data(slideshow);
    let slides = flkty.cells.map(cell => cell.element);
    let autoplayTimeout;

    function setAutoplay() {
        if (autoplayTimeout) clearTimeout(autoplayTimeout);

        let currentSlide = slides[flkty.selectedIndex];
        let slideAutoplay = parseInt(currentSlide.dataset.autoplay, 10) || parseInt(slideshow.dataset.autoplay, 10) || 5000;

        autoplayTimeout = setTimeout(() => {
            flkty.next();
            setTimeout(() => {
                restartVideosOnSlide(flkty.selectedIndex, flkty);
            }, 200);
        }, slideAutoplay);
    }

    flkty.on('change', function () {
        setTimeout(() => {
            setAutoplay();
        }, 100);
    });

    setTimeout(() => {
        setAutoplay();
    }, 200);
}

document.addEventListener("DOMContentLoaded", function () {
    const slideshows = document.querySelectorAll('slide-show-v2');
    slideshows.forEach(slideshow => {
        if (slideshow.flickityInstance) {
            setTimeout(() => {
                startCustomAutoplay(slideshow);
            }, 200);
        }
    });
});
